import { observer } from "mobx-react-lite";
import * as React from "react";
import { classNames } from "src/common/classNames";

import { SecSpecSelectStore } from "../SecSpecSelectStore";
import { TranslateStep } from "../TranslateStep";
import { SelectCatalogStep } from "./SelectCatalogStep";
import { SelectSpecStep } from "./SelectSpecStep";
import * as styles from "./shared.module.less";

type PropsTranslateSpecStep = {
  store: SecSpecSelectStore;
  current: TranslateStep;
};

export const TranslateSpecStep: React.FC<PropsTranslateSpecStep> = observer(
  ({ store, current }) => (
    <>
      <div
        style={{ height: "100%" }}
        className={classNames([
          [current !== TranslateStep.select, styles.hidden],
        ])}
      >
        <SelectSpecStep store={store} />
      </div>
      <div
        style={{ height: "100%" }}
        className={classNames([
          [current !== TranslateStep.translate, styles.hidden],
        ])}
      >
        <SelectCatalogStep store={store} />
      </div>
    </>
  ),
);
